/**
 * @generated SignedSource<<a8986d5bd9762b4c83c1e51b0d06d239>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveInstallmentExpired_charge$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentExpired_charge">;
  readonly " $fragmentType": "PaymentActiveInstallmentExpired_charge";
};
export type PaymentActiveInstallmentExpired_charge$key = {
  readonly " $data"?: PaymentActiveInstallmentExpired_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveInstallmentExpired_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveInstallmentExpired_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentExpired_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "6810e1bd815b5a990e5cb5e0a3f5a3ab";

export default node;
